import { render } from "./customerleadsForm.vue?vue&type=template&id=51c1801c"
import script from "./customerleadsForm.vue?vue&type=script&lang=js"
export * from "./customerleadsForm.vue?vue&type=script&lang=js"

import "./customerleadsForm.vue?vue&type=style&index=0&id=51c1801c&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__